import MultiColumn from "../../sections/multi-column";
import ProgressBar from "../../sections/checkout-progress-bar";
import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

const HeroProgressBar = ({
  backgroundImage,
  heading,
  subHeading,
  progressBar,
}) => {
  return (
    <MultiColumn
      backgroundImage={backgroundImage}
      className="checkout-progress-hero"
    >
      <h1 className="type-h1">{heading}</h1>
      <h2 className="type-h2">{subHeading}</h2>
      <ProgressBar {...progressBar} />
    </MultiColumn>
  );
};

HeroProgressBar.propTypes = {
  backgroundImage: PropTypes.string,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  progressBar: PropTypes.shape(ProgressBar.propTypes),
};

export default HeroProgressBar;
